import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { Input } from 'redpoints-front-components/index';
import { DEBOUNCE_INTERVAL } from 'redpoints-front-common/config';

import { allIncidentsFiltersSetSearchLinkUrl } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersSearchLinkUrl } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersSearchLinkUrl = ({
  allIncidentsFiltersSetSearchLinkUrl,
  searchLinkUrl,
}) => {
  const handleSearchLinkUrl = debounce(linkUrl => {
    allIncidentsFiltersSetSearchLinkUrl({ linkUrl });
  }, DEBOUNCE_INTERVAL);

  return (
    <Input
      aria-label="searchUrl-input"
      label={translate('reporting.allIncidentsInternal.filters.searchUrl')}
      value={searchLinkUrl}
      onChange={e => {
        handleSearchLinkUrl(e.target.value);
      }}
    />
  );
};

const mapStateToProps = state => {
  return {
    searchLinkUrl: getAllIncidentsFiltersSearchLinkUrl(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetSearchLinkUrl,
})(AllIncidentsFiltersSearchLinkUrl);
